// compare any two values deeply
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deepEquals = (lhs: any, rhs: any): boolean => {
  if (lhs === rhs) return true;
  if (typeof lhs !== 'object' || typeof rhs !== 'object' || lhs === null || rhs === null) {
    return false;
  }
  const keysA = Object.keys(lhs);
  const keysB = Object.keys(rhs);
  if (keysA.length !== keysB.length) return false;
  for (const key of keysA) {
    if (!keysB.includes(key) || !deepEquals(lhs[key], rhs[key])) {
      return false;
    }
  }
  return true;
};
